<script lang="ts">
    import { GlobalSearchStore } from "$/stores/GlobalSearchStore";
    import {
        formatDateToDateString,
        getHostnameFromUrl,
        removeImagesFromHtml,
    } from "$/utils/Utils";

    export let item;
    export let itemType = "snippet";
    export let generateUrl: (item: any) => string;

    export function focusItem() {
        itemRef.focus();
    }

    let itemRef: HTMLAnchorElement;
    let itemTypeText: string;
    let isLink = itemType.toLowerCase() === "link";

    const getItemTypeText = (type) => {
        switch (type.toLowerCase()) {
            case "comment":
                return (itemTypeText = "Comment");
            case "snippet":
                return (itemTypeText = "Snippet");
            case "topic":
                return (itemTypeText = "Topic");
            case "link":
                return (itemTypeText = "Link");
            default:
                return (itemTypeText = "");
        }
    };
</script>

<a
    class="global-search__results-item"
    href={generateUrl(item)}
    target={isLink ? "_blank" : undefined}
    on:click={() => { if(!isLink) GlobalSearchStore.closeSearchModal()}}
    bind:this={itemRef}
>
    <div class="global-search__results-item-left">
        <span class="global-search__results-item-text">
            {@html itemType.toLowerCase() === "snippet" ||
            itemType.toLowerCase() === "link"
                ? removeImagesFromHtml(item.content)
                : itemType.toLowerCase() === "comment"
                  ? removeImagesFromHtml(item.comment)
                  : item.name}
            {#if item.archived}
                <span class="archived-label">Archived</span>
            {/if}
        </span>

        {#if itemType.toLowerCase() === "snippet" || itemType.toLowerCase() === "link"}
            <span class="global-search__results-url">
                {getHostnameFromUrl(item.url)}
                {#if item.archived}
                    <span class="archived-label">Archived</span>
                {/if}
            </span>
        {/if}
    </div>
    <div class="global-search__results-item-right">
        {#if itemType.toLowerCase() !== "link"}
            <span class="global-search__results-item-right--created">
                {formatDateToDateString(item.createdOn)}
            </span>
        {/if}
        <span class="global-search__results-item-right--open">
            Open {getItemTypeText(itemType)}
        </span>
    </div>
</a>

<style>
    .global-search__results-item {
        @apply flex cursor-pointer flex-row rounded-sm px-4 py-2 hover:bg-gray-100;
    }

    .global-search__results-item:focus {
        @apply bg-gray-100 outline-none;
    }

    .global-search__results-item__right-icon {
        @apply ml-auto;
    }

    .global-search__results-item__right-icon svg {
        @apply h-4 w-4;
    }

    .global-search__results-item-left {
        @apply flex max-w-[80%] flex-col gap-1;
    }

    .global-search__results-item-text {
        @apply max-h-[22px] truncate text-sm;
    }

    .global-search__results-url {
        @apply text-xs text-gray-500;
    }

    .global-search__results-item-right {
        @apply ml-auto flex max-w-[20%] flex-col justify-center gap-1 text-xs font-semibold text-gray-600;
    }

    .global-search__results-item-right--open {
        @apply hidden;
    }

    .global-search__results-item:hover
        .global-search__results-item-right--created {
        @apply hidden;
    }

    .global-search__results-item:hover
        .global-search__results-item-right--open {
        @apply block;
    }

    .archived-label {
        @apply mr-0.5 mt-0.5 select-none rounded-full bg-gray-200 px-2 py-0.5 align-bottom text-3xs font-black uppercase text-gray-400 hover:bg-gray-300 hover:text-gray-900 !important;
    }
</style>
